import { AppBar, Box, Container } from "@mui/material";
import { lineaLogoW } from "../../commons/assets.js";

import "./index.css";

function NavBar() {
  return (
    <Box sx={{ display: "flex" }}>
      <AppBar component="nav" elevation={0} sx={{ backgroundColor: "#000" }}>
        <Container maxWidth="lg" sx={{ padding: "18px 0" }}>
          <div className="flex flex-wrap justify-between items-center">
            <div className="justify-self-start">
              <img src={lineaLogoW} alt="Linea logo" width="150px" />
            </div>
            {/* <div className="justify-self-end">
              <w3m-button size="sm" balance="show" />
            </div> */}
          </div>
        </Container>
      </AppBar>
    </Box>
  );
}

export default NavBar;
